import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../utils/aggrid-utils.js";

export default function EncounterActions({ encounterActions = [], selectedActions = [], onChange }){
    const gridRef = useRef();

    const rowSelection = useMemo(() => ({
        mode: "multiRow",
        enableSelectionWithoutKeys: true,
    }), []);

    const selectionColumnDef = useMemo(() => ({
        cellStyle: { paddingLeft: 16 },
        headerStyle: { paddingLeft: 16 },
    }), []);

    const columnDefs = useMemo(() => [
        {
            headerName: "Ação",
            field: "text",
            flex: 1,
        },
    ], []);

    const syncSelectedRows = useCallback(() => {
        const api = gridRef.current?.api;
        if (!api) return;

        const selectedIds = new Set((selectedActions ?? []).map((item) => item.id));

        api.forEachNode((node) => {
            const shouldBeSelected = selectedIds.has(node.data?.id);
            if (node.isSelected() !== shouldBeSelected) {
                node.setSelected(shouldBeSelected);
            }
        });
    }, [selectedActions]);

    useEffect(() => {
        syncSelectedRows();
    }, [encounterActions, syncSelectedRows]);

    const onSelectionChanged = useCallback(() => {
        const rows = gridRef.current?.api?.getSelectedRows?.() ?? [];
        onChange?.(rows);
    }, [onChange]);

    const onCellClicked = useCallback(({ node, colDef }) => {
        if (!node) return;
        if (colDef?.colId === "ag-Grid-SelectionColumn") return;
        node.setSelected(!node.isSelected());
    }, []);

    return (
        <div className="w-full h-[136px]">
            <AgGridReact
                ref={gridRef}
                rowData={encounterActions}
                columnDefs={columnDefs}
                rowSelection={rowSelection}
                selectionColumnDef={selectionColumnDef}
                defaultColDef={{ resizable: false }}
                getRowId={(params) => String(params.data.id)}
                animateRows={false}
                suppressCellFocus={true}
                onSelectionChanged={onSelectionChanged}
                onCellClicked={onCellClicked}
                gridOptions={{ localeText: AgGridUtils.localization() }}
                theme={AgGridUtils.generalTheme()}
            />
        </div>
    )
}